/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PhotoIntervalMode {
}

export enum PhotoIntervalMode_Enum {
  DISABLED = 0,
  INTERVAL_1_SEC = 1000,
  INTERVAL_2_SEC = 2000,
  INTERVAL_3_SEC = 3000,
  INTERVAL_5_SEC = 5000,
  INTERVAL_7_SEC = 7000,
  INTERVAL_10_SEC = 10000,
  INTERVAL_15_SEC = 15000,
  INTERVAL_20_SEC = 20000,
  INTERVAL_30_SEC = 30000,
  INTERVAL_60_SEC = 60000,
  UNRECOGNIZED = -1,
}

export function photoIntervalMode_EnumFromJSON(object: any): PhotoIntervalMode_Enum {
  switch (object) {
    case 0:
    case "DISABLED":
      return PhotoIntervalMode_Enum.DISABLED;
    case 1000:
    case "INTERVAL_1_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_1_SEC;
    case 2000:
    case "INTERVAL_2_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_2_SEC;
    case 3000:
    case "INTERVAL_3_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_3_SEC;
    case 5000:
    case "INTERVAL_5_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_5_SEC;
    case 7000:
    case "INTERVAL_7_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_7_SEC;
    case 10000:
    case "INTERVAL_10_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_10_SEC;
    case 15000:
    case "INTERVAL_15_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_15_SEC;
    case 20000:
    case "INTERVAL_20_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_20_SEC;
    case 30000:
    case "INTERVAL_30_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_30_SEC;
    case 60000:
    case "INTERVAL_60_SEC":
      return PhotoIntervalMode_Enum.INTERVAL_60_SEC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoIntervalMode_Enum.UNRECOGNIZED;
  }
}

export function photoIntervalMode_EnumToJSON(object: PhotoIntervalMode_Enum): string {
  switch (object) {
    case PhotoIntervalMode_Enum.DISABLED:
      return "DISABLED";
    case PhotoIntervalMode_Enum.INTERVAL_1_SEC:
      return "INTERVAL_1_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_2_SEC:
      return "INTERVAL_2_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_3_SEC:
      return "INTERVAL_3_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_5_SEC:
      return "INTERVAL_5_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_7_SEC:
      return "INTERVAL_7_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_10_SEC:
      return "INTERVAL_10_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_15_SEC:
      return "INTERVAL_15_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_20_SEC:
      return "INTERVAL_20_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_30_SEC:
      return "INTERVAL_30_SEC";
    case PhotoIntervalMode_Enum.INTERVAL_60_SEC:
      return "INTERVAL_60_SEC";
    case PhotoIntervalMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePhotoIntervalMode(): PhotoIntervalMode {
  return {};
}

export const PhotoIntervalMode = {
  encode(_: PhotoIntervalMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoIntervalMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoIntervalMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PhotoIntervalMode {
    return {};
  },

  toJSON(_: PhotoIntervalMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoIntervalMode>, I>>(base?: I): PhotoIntervalMode {
    return PhotoIntervalMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoIntervalMode>, I>>(_: I): PhotoIntervalMode {
    const message = createBasePhotoIntervalMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
